export function buildTaskRowsModel(dtoRows) {
  return dtoRows.map((item) => ({
    task: item.task,
    label: item.label,
    cronExpression: item.cronExpression,
    draftCronExpression: item.cronExpression,
    nextRunAt: item.nextRunAt,
    lastRunAt: item.lastRunAt,
    isActive: item.isActive,
  }));
}
